import React, { useEffect, useState } from "react";
import { adminApi } from "./adminApi";

export default function AdminReferrals() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            const r = await adminApi.referrals(500);
            setItems(r.items);
            setLoading(false);
        })();
    }, []);

    return (
        <div className="p-10 max-w-6xl" data-testid="admin-referrals">
            <span className="text-[10px] tracking-[0.36em] uppercase text-gold-deep">Network</span>
            <h1 className="mt-2 font-display text-5xl text-burgundy">
                <span className="italic">Who</span> brought who
            </h1>

            <div className="mt-8 border border-burgundy/15 bg-cream overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-cream-soft text-[10px] tracking-[0.28em] uppercase text-ink-muted">
                        <tr>
                            <th className="text-left px-4 py-3">Code</th>
                            <th className="text-left px-4 py-3">Referrer</th>
                            <th className="text-left px-4 py-3">Referred</th>
                            <th className="text-left px-4 py-3">When</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && (
                            <tr><td colSpan={4} className="px-4 py-10 text-center text-ink-muted">Loading…</td></tr>
                        )}
                        {!loading && items.length === 0 && (
                            <tr><td colSpan={4} className="px-4 py-10 text-center text-ink-muted">No referrals yet.</td></tr>
                        )}
                        {items.map(r => (
                            <tr key={r.id} className="border-t border-burgundy/10">
                                <td className="px-4 py-3 font-mono text-xs">{r.referral_code}</td>
                                <td className="px-4 py-3 font-mono text-[11px] text-ink-muted">
                                    {r.referrer?.session_id?.slice(0, 14) || "—"}…
                                </td>
                                <td className="px-4 py-3 font-mono text-[11px] text-ink-muted">
                                    {r.referred_session_id?.slice(0, 14)}…
                                </td>
                                <td className="px-4 py-3 text-xs text-ink-muted">
                                    {new Date(r.created_at).toLocaleString()}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
